import { MessageBox, Message } from 'element-ui';
import _ from 'lodash';
import router from './router';
import { TOKEN_STORAGE_KEY } from '@/constants';
import { i18n } from './i18n';
import urljoin from 'url-join';
import upload from './upload';

export default {
  componentPrefix: 'bean',
  screen: {
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1920
  },
  request: {
    baseURL: '/admin_api/v1',
    timeout: 60000,
    onSend: (request) => {
      const token = localStorage.getItem(TOKEN_STORAGE_KEY);
      const locale = i18n.locale;
      if (!request.headers.Authorization && token) {
        request.headers.Authorization = token;
      }
      if (localStorage.getItem('currentRoleId')) {
        request.headers['Current-Role-Id'] = +localStorage.getItem('currentRoleId')
      }
      if (!request.headers.Locale && locale) {
        request.headers.Locale = locale;
      }
    },
    onError: (err) => {
      const { error_message, message, messages, error, code } = _.get(err, 'response.data', {})
      err.message = error_message || message || messages || error || err.message;
      err.api_code = code;
      switch (err.status) {
        case 401: {
          localStorage.removeItem(TOKEN_STORAGE_KEY);
          if (router.currentRoute.name !== 'login') {
            router.replace({ name: 'login' });
            Message.info(i18n.t('pleaseLogin'));
          }
          break;
        }
        case 403:
          // 账号角色被移除时
          if (err.api_code === 40303) {
            localStorage.removeItem('currentRoleId');
            router.replace({ name: 'home' });
            location.reload()
          } else {
            router.replace({ name: '403' });
          }
          break;
        default: {
          if (_.get(err, 'request.$alert') !== false) {
            MessageBox.alert(err.message, { title: i18n.t('error') })
          }
        }
      }
      return err;
    }
  },
  upload: {
    resourceBlobURL: '/active_storage/blobs/read_options',
    resourceBlobTagURL: '/acts_as_taggable_on/tags/read_options',
    customUpload: async (file, body, { onProgress = _.noop } = {}) => {
      return upload(file, body, { onProgress });
    },
  },
  sourcePage: {
    // prop = id 默认加上排序
    sortable: ['id'],
    columns() {
      return []
    }
  },
  i18n: {
    localeStorageKey: 'locale',
    locales: {
      zh_cn: '简体中文',
      en: 'English',
    },
  },
  ckeditor: {
    contentsCss: [urljoin(process.env.BASE_URL, '/ckeditor-content.css')],
    editorConfig: function(config) {
      const pluginUrl = urljoin(process.env.BASE_URL, '/custom_editor_plugins/postbot/');
      window.CKEDITOR.plugins.addExternal('postbot', pluginUrl);
      config.extraPlugins = `${config.extraPlugins},postbot`;
      config.toolbar.push(['Postbot'])
      return config;
    },
    directUploadExtraBody: {
      source: 'wysiwyg'
    }
  },
}

